import { useAuth0 } from "@auth0/auth0-react"
import { Alert, Box, Button, Link } from "@mui/material"
import { FC, useEffect } from "react"
import { useSelector } from "react-redux"
import LoadingPage from "src/LoadingPage"
import { useAuthStrategy } from "src/auth/AuthStrategyContext"
import { selectIsMblsAuthenticated, selectMeErrorMessage } from "src/features/me/meSlice"

export const LoginPage: FC = () => {
  const authStrategy = useAuthStrategy()

  if (authStrategy === "auth0") {
    return <Auth0LoginPage />
  }

  // Parent (webapp cookie-proxy) strategy is authenticated by the host frame;
  // there is no interactive login here. Clerk's <SignIn> was removed in
  // LOCKER-319.
  return <LoadingPage />
}

const Auth0LoginPage: FC = () => {
  const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0()
  const isMblsAuthenticated = useSelector(selectIsMblsAuthenticated)
  const errorMessage = useSelector(selectMeErrorMessage)

  useEffect(() => {
    // Only redirect to Auth0 login if not already authenticated.
    // If already Auth0-authenticated but backend rejected, show error instead of looping.
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect()
    }
  }, [isLoading, isAuthenticated, loginWithRedirect])

  // Auth0 says authenticated but backend rejected — show error, don't loop
  if (isAuthenticated && isMblsAuthenticated === false) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", p: 3 }}>
        <Alert severity="error" sx={{ maxWidth: 480 }}>
          <strong>Authentication failed</strong>
          <Box sx={{ mt: 1 }}>
            {errorMessage || "Your account could not be verified by the server. Please contact your administrator."}
          </Box>
          <Box sx={{ mt: 2, display: "flex", gap: 2, alignItems: "center" }}>
            <Button variant="contained" size="small" onClick={() => window.location.reload()}>
              Retry
            </Button>
            <Link href="/signout" underline="hover">
              Sign out
            </Link>
          </Box>
        </Alert>
      </Box>
    )
  }

  return <LoadingPage />
}

export default LoginPage
